import { Container, Divider } from "@mui/material";
import Header from "./Header";
import TaimImg from "../images/TAIM-LAST.png";
import "../css/contact.css";
import MusicCard from "./MusicCard";
import Footer from "../Footer";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import { useLoading } from "../contexts/DisplayLoading";
import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";
export default function Contact() {
  // Snack Bar Handling //
  const [open, setOpen] = React.useState(false);
  const [snackProps, setSnackProps] = useState({
    message: "",
    severity: "",
  });

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  // Snack Bar Handling //
  // Regex for validating an email address

  const emailRegex =
    /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

  // Regex for validating a name (only letters and spaces allowed)
  const nameRegex = /^[A-Za-z\s]+$/;
  let { loading, DisplayLoading } = useLoading();
  DisplayLoading();
  const [form, setForm] = useState({
    name: "",
    email: "",
    companyName: "",
    messageTitle: "",
    messageBody: "",
  });
  function handleInputChange(type, content) {
    setForm({ ...form, [type]: content });
  }
  function clearForm() {
    setForm({
      name: "",
      email: "",
      companyName: "",
      messageTitle: "",
      messageBody: "",
    });
  }
  const userID = process.env.REACT_APP_EMAILJS_USER_ID;
  const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  // Initialize EmailJS with your User ID
  emailjs.init(userID);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!form.name || !form.email || !form.messageBody) {
      setSnackProps({
        ...snackProps,
        message: "Please fill in required fields",
        severity: "error",
      });
      setOpen(true);
      // alert("Please fill in required fields");
      return;
    }
    // Validate the name
    if (!nameRegex.test(form.name)) {
      setSnackProps({
        ...snackProps,
        message: "Name can only contain letters and spaces.",
        severity: "error",
      });
      setOpen(true);

      return;
    }

    // Validate the email address
    if (!emailRegex.test(form.email)) {
      setSnackProps({
        ...snackProps,
        message: "Please enter a valid email address.",
        severity: "error",
      });
      setOpen(true);

      return;
    }
    try {
      const response = await emailjs.send(
        serviceID, // From EmailJS dashboard
        templateID, // From EmailJS dashboard
        {
          name: form.name,
          email: form.email,
          companyName: form.companyName,
          messageTitle: form.messageTitle,
          messageBody: form.messageBody,
        },
      );

      if (response.status === 200) {
        setSnackProps({
          ...snackProps,
          message: "Message sent successfully!",
          severity: "success",
        });
        setOpen(true);

        clearForm();
      }
    } catch (error) {
      console.error("Failed to send:", error);
      setSnackProps({
        ...snackProps,
        message: "Failed to send message",
        severity: "error",
      });
      setOpen(true);
    }
  };

  // Rest of your component remains the same

  return (
    <>
      <div>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={snackProps.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackProps.message}
          </Alert>
        </Snackbar>
      </div>

      <div
        className="contact"
        style={{
          // backgroundColor: loading.isVisible ? "white" : "#202124",
          backgroundColor: "#202124",
          position: "relative",
          zIndex: "1",
          display: loading.isVisible ? "none" : "block",
        }}
      >
        <Header
          headerColor="white"
          hoverColor="white"
          shadowColor="transparent"
        />
        <Container maxWidth="lg" style={{ padding: "100px 0" }}>
          <div
            className="name-et-photo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h1 style={{ color: "white", fontSize: "60px", fontWeight: "500" }}>
              Let’s make your brand
              <span style={{ display: "block" }}> dance, not just scroll.</span>
            </h1>
            <img
              src={TaimImg}
              style={{
                maxWidth: "300px",
                borderRadius: "50%",
                boxShadow: "rgba(255, 255, 255, 0.36) 2px 2px 1px -1px",
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <div
              className="message-et-info"
              style={{
                display: "flex",
                position: "relative",
                color: "white",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div className="music-card">
                <MusicCard />
              </div>
              <div
                className="form-container"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="message-form"
                  style={{ color: "white", width: "70%" }}
                >
                  <Divider sx={{ borderColor: "white", margin: "15px 0" }} />
                  <h3>What do your friends call you?</h3>
                  <input
                    value={form.name}
                    placeholder="Jhon Cena"
                    onChange={(event) =>
                      handleInputChange("name", event.target.value)
                    }
                  />
                  <Divider sx={{ borderColor: "white", margin: "15px 0" }} />
                  <h3>Where can I send you a virtual high-five?</h3>
                  <input
                    value={form.email}
                    placeholder="JhonCena@gmail.com"
                    onChange={(event) =>
                      handleInputChange("email", event.target.value)
                    }
                  />
                  <Divider sx={{ borderColor: "white", margin: "15px 0" }} />
                  <h3>What’s the name of your Company?</h3>
                  <input
                    value={form.companyName}
                    placeholder="Company Name Here "
                    onChange={(event) =>
                      handleInputChange("companyName", event.target.value)
                    }
                  />
                  <Divider sx={{ borderColor: "white", margin: "15px 0" }} />
                  <h3>What Service you Looking For ?</h3>
                  <input
                    value={form.messageTitle}
                    placeholder="Web-devolmpent"
                    onChange={(event) =>
                      handleInputChange("messageTitle", event.target.value)
                    }
                  />
                  <Divider sx={{ borderColor: "white", margin: "15px 0" }} />
                  <h3>What’s on your mind?</h3>
                  <textarea
                    value={form.messageBody}
                    onChange={(event) =>
                      handleInputChange("messageBody", event.target.value)
                    }
                    placeholder="Hi Taim, I’d like to discuss a service for... "
                    style={{
                      width: "100%",
                      fontSize: "18px",
                      padding: "15px",
                      border: "none",
                      backgroundColor: "transparent",
                      resize: "none",
                      color: "white",
                      outline: "none",
                    }}
                  />
                </form>
                <div className="socails-contact">
                  <div>
                    <span>Contact Info :</span>
                    <Link
                      href="mailto:taim.jaber.dev@gmail.com"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">taim.jaber.dev@gmail.com</h3>
                    </Link>
                    <Link
                      href="tel:+963996621746"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">+963996621746</h3>
                    </Link>
                  </div>

                  <div>
                    <span>Location</span>
                    <h3>country : Syria</h3>
                    <h3>city : As-Swayda</h3>
                  </div>

                  <div className="Socail-medias">
                    <span>Socails</span>
                    <Link
                      href="https://wa.me/+963996621746"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">Whatsapp</h3>
                    </Link>
                    <Link
                      href="https://www.facebook.com/Taimjr10/"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">Facebook</h3>
                    </Link>
                    <Link
                      href="https://github.com/Taim-Gr"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">Github</h3>
                    </Link>
                    <Link
                      href="https://www.linkedin.com/in/taim-jaber-90621237b/"
                      target="_blank"
                      underline="none"
                    >
                      <h3 className="clickable">LinkedIn</h3>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              margin: "20px 0",
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <Divider
              sx={{
                borderColor: "#3d3838",
                width: "50%",
                position: "absolute",
                bottom: "0",
              }}
            />
            <div style={{ overflow: "hidden" }}>
              <button
                onClick={(e) => {
                  handleSubmit(e);
                }}
                className="Throw-me-btn"
                style={{
                  width: "200px",
                  height: "200px",
                  border: "none",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  color: "black",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              ></button>
            </div>
          </div>
        </Container>
        <Footer />
      </div>
    </>
  );
}
